import React, { Component } from 'react';
import ConditionedComponent from 'components/ConditionedComponent.js';
import SingleLFOComponent from './SingleLFOComponent.js';
import SystemEnvelopeComponent from 'components/envelope/SystemEnvelopeComponent.js';
import {setShowEnvelopes} from 'actions/index.js';
import {setShowLFOs} from 'actions/index.js';
import { connect } from "react-redux";
import {setContextualHelp} from "actions/index.js";
import {LFOS_BUTTON} from 'constants/contextual-help.js';
import {ENVELOPES_BUTTON} from 'constants/contextual-help.js';

class LFOTrackComponent extends Component {

    get patternLocked() {
        if (this.props.showLFOs) {
            return this.props.lfoPatternLocked;
        } else if (this.props.showEnvelopes) {
            return this.props.envelopePatternLocked;
        }
        return false;
    }

    onClickLFOThumbnail() {
        this.props.setShowEnvelopes(false);
        this.props.setShowLFOs(!this.props.showLFOs);
    }

    onClickEnvelopeThumbnail() {
        this.props.setShowLFOs(false);
        this.props.setShowEnvelopes(!this.props.showEnvelopes);
    }

    onClickLock() {
        if (this.props.showLFOs) {
            this.props.lfosTrack.togglePatternLocked();
        } else if (this.props.showEnvelopes) {
            this.props.envelopesTrack.togglePatternLocked();
        }
    }

    render() {
        let className = this.props.isMixView ? 'track flex lfos-track mix-view' : 'track flex lfos-track';
        let lfoThumbnailClassName = this.props.showLFOs ?
            'lfo-thumbnail selected' : 'lfo-thumbnail';
        let envelopeThumbnailClassName = this.props.showEnvelopes ?
            'lfo-thumbnail selected' : 'lfo-thumbnail';
        return (
            <div
              key={'lfo-tracks'}
              onClick={() => []} className={className}>
              <a name='lfos'/>
              <a name='envelopes'/>
              <div className='unselected youtube-container'>
                <div className='lfo-envelope-button-container'>
                  <div
                    onMouseOver={() => this.props.setContextualHelp(LFOS_BUTTON)}
                    onMouseLeave={() => this.props.setContextualHelp(undefined)}
                    onClick={() => this.onClickLFOThumbnail()} 
                    className={lfoThumbnailClassName}>
                    LFO
                  </div>
                  <div 
                    onMouseOver={() => this.props.setContextualHelp(ENVELOPES_BUTTON)}
                    onMouseLeave={() => this.props.setContextualHelp(undefined)}
                    onClick={() => this.onClickEnvelopeThumbnail()} 
                    className={envelopeThumbnailClassName}>
                    ENV
                  </div>
                </div>
              </div>
              <ConditionedComponent condition={this.props.showLFOs}>
                <div className="lfo-effects-view">
                  {this.props.lfosTrack.lfos.map(
                      lfo => 
                          <SingleLFOComponent key={lfo.number} sequencerEngine={this.props.sequencerEngine} lfo={lfo}/>)}
                </div>
             </ConditionedComponent>
              <ConditionedComponent condition={this.props.showEnvelopes}>
                <div className="lfo-effects-view">
                  {this.props.envelopesTrack.envelopes.map(
                      envelope => 
                    <SystemEnvelopeComponent
                      key={envelope.number}
                      scrollContainer={this.props.scrollContainer}
                      sequencerEngine={this.props.sequencerEngine}
                      envelopeTrack={envelope}/>)}
                </div>
              </ConditionedComponent>
              <ConditionedComponent condition={this.props.showLFOs || this.props.showEnvelopes}>
                <div className="lock-button-container">
                  <img
                    onClick={() => this.onClickLock()}
                    className="lock-button"
                    src={this.patternLocked ? "/closed-padlock.png" : "/opened-padlock.png"}/>
                </div>
              </ConditionedComponent>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setShowEnvelopes: s => dispatch(setShowEnvelopes(s)),
        setShowLFOs: s => dispatch(setShowLFOs(s)),
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
    };
};

const mapStateToProps = (state, props) => {
    let subSequenceEnvelopeLocks = state.tracks.envelopePatternLocks[props.envelopesTrack.subSequence.id] || {};
    let envelopePatternLocked = subSequenceEnvelopeLocks[props.sequencerEngine.currentPattern];
    let subSequenceLFOLocks = state.tracks.lfoPatternLocks[props.lfosTrack.subSequence.id] || {};
    let lfoPatternLocked = subSequenceLFOLocks[props.sequencerEngine.currentPattern];
    return {
        showLFOs: state.sequencer.showLFOs,
        showEnvelopes: state.sequencer.showEnvelopes,
        lfoPatternLocked: lfoPatternLocked,
        envelopePatternLocked: envelopePatternLocked,
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(LFOTrackComponent);
